import React from 'react';
import { Wifi, WifiOff, AlertTriangle } from 'lucide-react';
import useSessionStore from '@/stores/sessionStore';
import { useTranslation } from 'react-i18next';

const ConnectionStatus = () => {
  const { t } = useTranslation();
  const { connectionQuality, isConnected, isConnectionEstablishing } = useSessionStore();

  if (!isConnected) {
    return (
      <div className="flex items-center space-x-2 text-red-400">
        <WifiOff className="w-4 h-4" />
        <span className="text-sm">{t('liveSession.connection.disconnected', 'Disconnected')}</span>
      </div>
    );
  }

  // During stabilization, suppress "Unstable" to avoid false alarms
  // but show good/excellent normally
  const effectiveQuality = (isConnectionEstablishing && connectionQuality === 'poor') 
    ? 'good' 
    : connectionQuality;

  const getStatusColor = () => {
    switch (effectiveQuality) {
      case 'excellent':
        return 'text-green-400';
      case 'good':
        return 'text-green-400';
      case 'poor':
        return 'text-yellow-400';
      case 'lost':
        return 'text-red-400';
      default:
        return 'text-gray-400';
    }
  };

  const getStatusText = () => {
    switch (effectiveQuality) {
      case 'excellent':
        return t('liveSession.connection.excellent', 'Excellent');
      case 'good':
        return t('liveSession.connection.good', 'Good');
      case 'poor':
        return t('liveSession.connection.unstable', 'Unstable');
      case 'lost':
        return t('liveSession.connection.lost', 'Lost');
      default:
        return t('liveSession.connection.unknown', 'Unknown');
    }
  };

  const getIcon = () => {
    switch (effectiveQuality) {
      case 'poor':
      case 'lost':
        return <AlertTriangle className="w-4 h-4" />;
      default:
        return <Wifi className="w-4 h-4" />;
    }
  };

  return (
    <div className={`flex items-center space-x-2 ${getStatusColor()}`}>
      {getIcon()}
      <span className="text-sm">{getStatusText()}</span>
    </div>
  );
};

export default ConnectionStatus;